<template>
  <div>
    <v-toolbar color="grey lighten-2" absolute flat height="24em" tabs>
      <template slot="extension">
        <img v-if="$store.getters.isClubRole" :src="$store.state.icon" class="logo club-logo">
        <v-tabs v-model="tabs" centered flat icons-and-text class="pb-4" color="grey lighten-2" style="margin-right: 64px">
          <v-tab href="#tab-1">Redes Sociales_<v-icon>share</v-icon></v-tab>
          <v-tab v-if="this.$store.state.pantallas.screenActiveDashboardCalendario" href="#tab-2">Calendario<v-icon>event_note</v-icon></v-tab>
          <v-tab href="#tab-3" v-if="canViewVencimientos">Vencimientos<v-icon>date_range</v-icon></v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <DashboardPopUpDialog
    ref="draftInProgressDialog"
    title="Actualización en curso pendiente"
    text="¿Desea continuar hacia la actualización?"
    icon="error_outline"
    iconSize="45"
    iconColor="info"
    :function-yes="navigateToDraft"
    :max-width="400"
    >

    </DashboardPopUpDialog>
    <v-tabs-items v-model="tabs" class="top-spacing">
      <v-tab-item value="tab-1">
        <SocialNetworks></SocialNetworks>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <Calendar v-model="hideDetailsOnCalendar" :delay="delay"></Calendar>
      </v-tab-item>
      <v-tab-item value="tab-3" v-if="canViewVencimientos">
        <div v-if="$store.state.permissions.canViewVencimientos">
          <PresentationToExpireTable>
            <div class="custom-font-regular large-text custom-blue-text mb-2">Presentaciones pendientes
            </div>
            <v-divider class="mt-2 mb-3"></v-divider>
          </PresentationToExpireTable>
          <component :is="expirationTable" class="mt-4">
            <span class="custom-font-regular large-text custom-blue-text mb-2">Documentación a vencer</span>
            <v-divider class="mt-2 mb-3"></v-divider>
          </component>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ExpirationsTableSaf from '../components/ExpirationsTableSaf'
import ExpirationsTableClub from '../components/ExpirationsTableClub'
import PresentationToExpireTable from '../components/PresentationToExpireTable'
import SocialNetworks from '../components/SocialNetworks'
import Calendar from '../components/Calendar'
import DashboardPopUpDialog from '../../../common/ui/DashboardPopUpDialog.vue'

export default {
  components: {
    ExpirationsTableSaf,
    ExpirationsTableClub,
    PresentationToExpireTable,
    SocialNetworks,
    Calendar,
    DashboardPopUpDialog
  },

  data () {
    return {
      tabs: null,
      hideDetailsOnCalendar: false,
      delay: new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 500)
      })
    }
  },

  computed: {
    expirationTable () {
      return 'ExpirationsTable' + this.$store.getters.role
    },
    canViewVencimientos () {
      return this.$store.state.permissions.canViewVencimientos
    }
  },

  beforeRouteLeave (to, from, next) {
    this.hideDetailsOnCalendar = true
    this.delay.then(() => {
      next()
    })
  },
  methods: {
    navigateToDraft () {
      this.$router.push({ name: 'draft' })
    }
  },
  watch: {
    '$store.state.showDraftNotification' () {
      this.$refs.draftInProgressDialog.openDialog()
      this.$store.commit('changeshowDraftNotification', false)
    }
  }

}
</script>

<style scoped>
.large-text {
  font-size: 1.5em;
}
.custom-blue-text {
  color: #293968;
}
.top-spacing {
  margin-top: 5em;
}
.club-logo {
  height: 64px;
  margin-bottom: 24px;
}
</style>
